<template>
    <v-card
        class="mx-auto pa-4"
        :class="{ 'soli-round': $vuetify.breakpoint.smAndUp }"
    >
        <v-card-title class="soli-grey">{{
            referralSuccess ? "Refer another friend? " : "Refer a friend"
        }}</v-card-title>
        <v-card-subtitle
            >These lessons for your friend come with no strings attached. We
            just want to say thanks to you, and to share Musicologie with
            someone who might benefit.</v-card-subtitle
        >
        <v-col>
            <v-form ref="form" @submit.prevent="submit">
                <SoliText
                    v-model="form.first_name"
                    icon="person"
                    label="Friend's First Name"
                    :rules="[(v) => !!v || 'First name is required']"
                    hideDetails="auto"
                    :error="errors.first_name"
                    class="mb-4"
                />
                <SoliText
                    v-model="form.last_name"
                    icon="person"
                    label="Friend's Last Name"
                    hideDetails="auto"
                    :error="errors.last_name"
                    class="mb-4"
                />
                <BookingEmail
                    hideDetails="auto"
                    label="Friend's Email"
                    v-model="form.email"
                    :error="form.email"
                    class="mb-4"
                /><FormSubmit
                    valid
                    :errors="errors"
                    gradient="gradient-orange"
                    icon="send"
                    type="submit"
                    :loading="loading"
                    contained
                ></FormSubmit>
            </v-form>
        </v-col>
    </v-card>
</template>

<script>
import BookingEmail from "../Booking/BookingEmail.vue";
import FormSubmit from "../Form/FormSubmit.vue";
import confetti from "canvas-confetti";

export default {
    components: {
        BookingEmail,
        FormSubmit,
    },
    props: {
        errors: {},
        surveyID: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                survey_id: this.surveyID,
            }),
            loading: false,
            showLocations: false,
            showInstruments: false,
            referralSuccess: false,
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            this.form.post(route("referral.store"), {
                preserveState: true,
                preserveScroll: false,
                onSuccess: () => {
                    this.loading = false;
                    this.referralSuccess = true;
                    this.reset();
                    this.$emit("success");
                    confetti({
                        particleCount: 100,
                        spread: 70,
                        origin: { y: 0.6 },
                    });
                },
                onError: (errors) => {
                    this.loading = false;
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    if (errors.contactSupport) return;
                    if (errors.soliError) return;
                },
            });
        },
        reset() {
            this.$refs.form.reset();
        },
    },
};
</script>
